// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expand-code-wrapper[data-v-749c7530]{position:absolute;bottom:0;left:0;z-index:100;width:100%;height:40px;line-height:40px;text-align:center;background-image:linear-gradient(0deg,#fff,transparent)}.expand-code-wrapper .text[data-v-749c7530]{display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;height:32px;padding:3px 10px;color:#fff;font-size:14px;line-height:32px;background:var(--motif-300);border-radius:4px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
